import React, { useEffect, useRef } from "react";
import AmbassadorMessage from "../Ambasador/AmbassadorMessage";
import PresidentMessage from "../President/PresidentMessage";
import AboutSection from "../About/About";

import MissionVision from "../About/MissionVission";
import BoardGallery from "../About/BoardMember";
import MinisterMessage from "../About/MinsterMessage";
import Core from "../About/Core";
import StrategicSection from "../home/components/Strategic";

import {
  HiOutlineCube,
  HiOutlineUserGroup,
  HiOutlinePresentationChartLine,
  HiOutlineScale,
  HiOutlineArrowRight,
} from "react-icons/hi";

// Safe fallbacks for animations
const safeUseReveal = () => {
  try {
    // @ts-ignore
    if (typeof useReveal === "function") return useReveal();
  } catch (e) {}
  return null;
};

const safeHide = (direction) => {
  try {
    // @ts-ignore
    if (typeof hide === "function") return hide(direction);
  } catch (e) {}
  return {};
};

// --- Main Page Component ---
export default function AboutPage() {
  return (
    <main className="bg-white overflow-hidden font-sans pt-20">
      {/* Hero Header */}
      <section className="bg-[#0F1C35] pt-32 pb-24 lg:pt-40 lg:pb-32 relative overflow-hidden">
        {/* Decorative Background Element */}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-[#C9952A]/5 skew-x-12 translate-x-20 pointer-events-none" />

        <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
          <div className="max-w-3xl mx-auto text-center flex flex-col items-center">
            <h1
              data-r
              className="text-5xl md:text-6xl lg:text-7xl font-black text-[#0077b6] leading-tight tracking-tight"
              style={safeHide("up")}
            >
              About BICCI
            </h1>

            <p
              data-r
              className="mt-6 text-xl text-gray-300 font-light leading-relaxed"
              style={safeHide("up")}
            >
              Bangladesh &middot; Italy Relations
            </p>
          </div>
        </div>
      </section>

      {/* Main Content Sections */}
      {/* <AboutSection /> */}

      {/* Mission & Vision Section */}
      <div id="mission-vision">
        <MissionVision />
      </div>

      {/* Core Values Section */}
      <div id="core-values">
        <Core />
      </div>

      {/* Strategy Section */}
      <div id="strategy">
        <StrategicSection />
      </div>

      {/* Ambassador's Message Section */}
      {/* <div id="ambassador-message">
        <AmbassadorMessage />
      </div> */}

      {/* <div id="minister-message">
        <MinisterMessage />
      </div> */}
      {/* President's Message Section */}
      {/* <div id="president-message">
        <PresidentMessage />
      </div> */}

      {/* Minister of Commerce Message Section */}

      {/* Board Members Section */}
      <div id="board-members">
        <BoardGallery />
      </div>
    </main>
  );
}
